import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const AutoCarousel = ({ project }) => {
  const images = [project?.image1, project?.image2, project?.image3];

  return (
    <Carousel
      autoPlay
      infiniteLoop
      showStatus={false}
      showIndicators={false}
      showThumbs={false}
      className="carousel-wrapper"
    >
      {images.map((image, index) => (
        <div key={index} className="carousel-slide">
          <img src={image} alt={`${index}`} className="carousel-image" />
        </div>
      ))}
    </Carousel>
  );
};

export default AutoCarousel;
